import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/ironwood-logo.svg'


const _hoisted_1 = {
  class: "navbar navbar-expand-lg navbar-light fixed-top",
  id: "mainNav"
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Ironwood Logo",
    class: "mx-2",
    style: {"padding-bottom":"5px","height":"2em","filter":"invert(79%) sepia(38%) saturate(4886%) hue-rotate(2deg)\n              brightness(107%) contrast(95%)"}
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, "ironwood whistles", -1)
const _hoisted_5 = {
  class: "navbar-toggler navbar-toggler-right",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarResponsive",
  "aria-controls": "navbarResponsive",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse navbar-collapse",
  id: "navbarResponsive"
}, [
  /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav ms-auto" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item dropdown" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link dropdown-toggle",
        href: "#",
        id: "navbarDropdown",
        role: "button",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false"
      }, " whistles "),
      /*#__PURE__*/_createElementVNode("ul", {
        class: "dropdown-menu border-0",
        "aria-labelledby": "navbarDropdown"
      }, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "dropdown-item",
            href: "/#prices"
          }, "prices")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "dropdown-item",
            href: "/#custom"
          }, "custom whistles")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link",
        href: "/#about"
      }, "about ironwood")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link",
        href: "/#contact"
      }, "contact")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", _hoisted_5, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-bars" }),
        _hoisted_6
      ]),
      _hoisted_7
    ])
  ]))
}